import { render } from "./CreateQuote.vue?vue&type=template&id=54b7b94c"
import script from "./CreateQuote.vue?vue&type=script&lang=js"
export * from "./CreateQuote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__